import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/InsertManagement';

function InsertManagement() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default InsertManagement;
